import React, { Component } from 'react'
import styled from 'styled-components'
import Container from '../components/Container'
import Footer from '../components/Footer'
import MainLayout from './index'
import { media } from '../theme'

const StyledContainer = styled(Container)`
  background: linear-gradient(215deg, #059ca6, #81b678, #ebd38b);
  height: 100%;
  overflow: hidden;
  padding-top: calc(${p => p.theme.spacing(3.25)} + ${p => p.theme.spacing(1)});
  z-index: 0;

  ${media.greaterThan('medium')`
    padding-top: calc(${p => p.theme.spacing(4)} + ${p => p.theme.spacing(3)});
  `};
`

const StyledFooter = styled(Footer)`
  background: linear-gradient(to right, #3b8e64, #103027);
`

export default class RoomGreenLayout extends MainLayout {
  static Container = StyledContainer
  static Footer = StyledFooter
}



// WEBPACK FOOTER //
// ./src/layouts/room-green.js